import { gql } from '@apollo/client'

export const WEBHOOKS_QUERY = gql`
  query WebhooksQuery($pageInfo: PageInfoInput!) {
    webhooks(pageInfo: $pageInfo) {
      items {
        webhookId
        url
        webhookStatus
        eventType
        authType
        timeoutMilliseconds
        createdBy {
          employeeId
          firstName
          lastName
          status
        }
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`

export const WEBHOOK_QUERY = gql`
  query WebhookQuery($webhookId: String!) {
    webhook(webhookId: $webhookId) {
      webhookId
      url
      webhookStatus
      eventType
      authType
      oauthTokenUrl
      clientId
      timeoutMilliseconds
      createdAt
      updatedAt
      headers {
        headerId
        key
        value
        isAuth
      }
      oauthParams {
        oauthParamId
        key
        value
      }
    }
  }
`

export const CREATE_WEBHOOK = gql`
  mutation CreateWebhookMutation($input: CreateWebhookInput!) {
    createWebhook(input: $input) {
      webhookId
      url
      webhookStatus
      eventType
      authType
      createdAt
    }
  }
`

export const UPDATE_WEBHOOK = gql`
  mutation UpdateWebhookMutation(
    $webhookId: String!
    $input: UpdateWebhookInput!
  ) {
    updateWebhook(webhookId: $webhookId, input: $input) {
      webhookId
      url
      webhookStatus
      eventType
      authType
      updatedAt
    }
  }
`

export const DELETE_WEBHOOK = gql`
  mutation DeleteWebhookMutation($webhookId: String!) {
    deleteWebhook(webhookId: $webhookId) {
      webhookId
    }
  }
`
